import React, { memo as Memo, useMemo } from 'react'

//* HOC's
import { withDataContext, withLanguageContext } from 'context'

//* Components
import { Page, ImgTextComp } from 'components/common'
import { SupportTopSection, SupportContactSection, SupportTopSecondSection } from 'components/pages'

//* Styles
import SupportUsStyle from 'styles/pages/SupportUsStyle'

const SupportUs = Memo(({ selectedLang, pageParams, pages }) => {

    //! Page Data
    const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name])

    return (
        <Page className='SupportUs' meta={pageData?.content.meta} >
            {
                pageData ? (
                    <SupportUsStyle>
                        <SupportTopSection />
                        <SupportTopSecondSection description={pageData.content.section_1_text} />

                        <ImgTextComp
                            title={pageData.content.section_2_title}
                            description={pageData.content.section_2_text}
                            bigImage={pageData.content.section_2_big_image}
                            smallImage={pageData.content.section_2_small_image}
                            typeImage={'supportFirstSectiion'}
                            titleSize="p"
                            className="articleSection reversColor"
                        />

                        <ImgTextComp
                            title={pageData.content.section_3_title}
                            description={pageData.content.section_3_text}
                            bigImage={pageData.content.section_2_big_image}
                            typeImage={'supportSecondSectiion'}
                            className="h6"
                        />

                        <SupportContactSection
                            title={pageData.content.section_4_title}
                            description={pageData.content.section_4_text}
                        />
                    </SupportUsStyle>

                ) : ''
            }
        </Page>
    )
})

export default withLanguageContext(withDataContext(SupportUs, ['pages']), ['selectedLang'])